import api from '@/services/api/config';

const path = 'v1/produktion/maschine';

export default {
  get: (page, size, sort = null, desc = false, abteilung = null) => api.get(path, {
    params: {
      page, size, sort, desc, abteilung,
    },
  }),
  getById: (id) => api.get(`${path}/${id}`),
};
